////////LIBRARY/////////
import { getItem } from '../../../utils/cookiesHelper'
import * as c from '../../../constants'

export const selectFieldInitialValue = () => {
  let siteLangCookie = getItem(c.siteLanguage)
  if (siteLangCookie) siteLangCookie = parseInt(siteLangCookie, 10)
  return siteLangCookie || 1
}
